import React, { useContext } from 'react';

import { BoxProps } from '../../../../Components/UI/Box';
import { ProjectContext } from '../../Context';
import MobileNavigation from '../MobileNavigation';

const ProjectsMobileNavigation: React.FC<BoxProps> = (props) => {
  const { department } = useContext(ProjectContext);

  return <MobileNavigation department={department} {...props} />;
};

export default ProjectsMobileNavigation;
